import { CommonGet, CommonPost } from '../../../utils/CommonFetch';
import tokenDecoder from '../../../components/Common/tokenDecoder';
import { parse } from 'date-fns';

export default {
    getGroups,
    getOperationalEntityByGroupEntityID,
    getCollectionPointsByOperationentityGroupID,
    getMaternityLeaveRecords,
    saveMaternityLeaveBulk,
    updateMaternityLeave,
    deleteMaternityLeave,
    getLeaveTypesByOperationEntity,
    getEmployeeByRegistrationNumber,
    getMaternityLeaveByID,
    checkDuplicateLeave,
    CheckDuplicateLeaveForUpdate
};

async function getGroups() {
    let response = await CommonGet('/api/Group/GetAllGroups', null);
    let groupArray = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getOperationalEntityByGroupEntityID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID', 'groupID=' + groupID)
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return array;
}

async function getCollectionPointsByOperationentityGroupID(operationEntityID, groupID) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["operationEntityID"] === parseInt(operationEntityID) && item[1]["groupID"] === parseInt(groupID) && item[1]["isActive"] === true) {
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;
}

async function getLeaveTypesByOperationEntity(operationEntityID) {
    var response = await CommonGet('/api/MaternityLeave/GetLeaveTypesByOperationEntity', 'operationEntityID=' + operationEntityID);
    let leaveTypeArray = [];

    if (response.data != null) {
        for (let item of Object.entries(response.data)) {
            leaveTypeArray[item[1]["leaveTypeID"]] = item[1]["leaveTypeName"];
        }
    }

    return leaveTypeArray;
}

async function getMaternityLeaveRecords(groupID, operationEntityID, collectionPointID, registrationNumber, leaveTypeID, fromDate, toDate) {
    var model = {
        groupID: parseInt(groupID),
        operationEntityID: parseInt(operationEntityID),
        collectionPointID: parseInt(collectionPointID) || 0,
        registrationNumber: registrationNumber || null,
        leaveTypeID: parseInt(leaveTypeID) || 0,
        fromDate: fromDate || null,
        toDate: toDate || null
    };
    var response = await CommonPost('/api/MaternityLeave/GetMaternityLeaveRecords', null, model);
    return response.data;
}

async function saveMaternityLeaveBulk(dataList) {
    var dataModelList = dataList.map(data => ({
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        collectionPointID: parseInt(data.collectionPointID),
        registrationNumber: data.registrationNumber,
        leaveTypeID: parseInt(data.leaveType),
        fromDate: data.fromDate,
        toDate: data.toDate,
        createdBy: parseInt(data.createdBy)
    }));
    var result = await CommonPost('/api/MaternityLeave/SaveMaternityLeaveBulk', null, dataModelList);
    return result;
}

async function updateMaternityLeave(model) {
    var result = await CommonPost('/api/MaternityLeave/UpdateMaternityLeave', null, model);
    return result;
}

async function deleteMaternityLeave(model) {
    var result = await CommonPost('/api/MaternityLeave/DeleteMaternityLeave', null, model);
    return result;
}

async function getEmployeeByRegistrationNumber(registrationNumber, groupID, operationEntityID, collectionPointID) {
    var model = {
        registrationNumber: registrationNumber,
        groupID: parseInt(groupID),
        operationEntityID: parseInt(operationEntityID),
        collectionPointID: collectionPointID ? parseInt(collectionPointID) : null
    };
    var response = await CommonPost('/api/MaternityLeave/GetEmployeeByRegistrationNumber', null, model);
    return response.data;
}

async function getMaternityLeaveByID(maternityLeaveID) {
    var response = await CommonGet('/api/MaternityLeave/GetMaternityLeaveByID', 'maternityLeaveID=' + maternityLeaveID);
    return response.data;
}

async function checkDuplicateLeave(model) {
    var response = await CommonPost('/api/MaternityLeave/CheckDuplicateLeave', null, model);
    return response.data;
}

async function CheckDuplicateLeaveForUpdate(model) {
    var response = await CommonPost('/api/MaternityLeave/CheckDuplicateLeaveForUpdate', null, model);
    return response.data;
}